const initialState = {
  mobileSidebar: false
};

export default initialState;
